import { caseStudyImages } from "../assets/case-study/case-study"

export const CaseStudyContentConfig = [
    {
        pageName: "iot-case-study",
        title: "IoT Solutions - Realtime Vehicle Telemerty",
        backgroundImage: caseStudyImages.hero.iot,
        url: "/resources/iot_case_study"
    },
    {
        pageName: "ai-case-study",
        title: "Machine Learning",
        backgroundImage: caseStudyImages.hero.ai,
        url: "/resources/ai_case_study"
    },
    {
        pageName: "cloud-case-study",
        title: "Cloud Computing",
        backgroundImage: caseStudyImages.hero.cloud,
        url: "/resources/cloud_case_study"
    },
    {
        pageName: "devops-case-study",
        title: "AWS DevOps - Automation of Deployments",
        backgroundImage: caseStudyImages.hero.devops,
        url: "/resources/rpa_case_study"
    },
    // {
    //     pageName: "rpa-case-study",
    //     title: "Robotic Process Automation",
    //     backgroundImage: caseStudyImages.hero.testing,
    //     url: "/resources/rpa_case_study"
    // },
    {
        pageName: "crossplatform-case-study",
        title: "Cross Platform Application- eCommerce",
        backgroundImage: caseStudyImages.hero.crossplatform,
        url: "/resources/crossplatform_case_study"
    },
    {
        pageName: "emr-case-study",
        title: "Electronic Medical Records Application",
        backgroundImage: caseStudyImages.hero.testing,
        url: "/resources/emr_case_study"
    },
    {
        pageName: "ocr-case-study",
        title: "OCR Case Study",
        backgroundImage: caseStudyImages.hero.ml,
        url: "/resources/ocr_case_study"
    },
    {
        pageName: "blockchain-case-study",
        title: "Blockchain Based Voting System",
        backgroundImage: caseStudyImages.hero.blockchain,
        url: "/resources/blockchain_case_study"
    },
    {
        pageName: "android-case-study",
        title: "Android App Development",
        backgroundImage: caseStudyImages.hero.androidapp,
        url: "/resources/android_case_study"
    }
]

export const caseStudyUrlRouting = [
    {
        pathname: "/resources/iot_case_study",
        pageName: "iot-case-study",
    },
    {
        pathname: "/resources/ai_case_study",
        pageName: "ai-case-study",
    },
    {
        pathname: "/resources/cloud_case_study",
        pageName: "cloud-case-study",
    },
    {
        pathname: "/resources/rpa_case_study",
        pageName: "devops-case-study",
    },
    // {
    //     pathname: "/resources/rpa_case_study",
    //     pageName: "rpa-case-study",
    // },
    {
        pathname: "/resources/crossplatform_case_study",
        pageName: "crossplatform-case-study",
    },
    {
        pathname: "/resources/emr_case_study",
        pageName: "emr-case-study",
    },
    {
        pathname: "/resources/ocr_case_study",
        pageName: "ocr-case-study",
    },
    {
        pathname: "/resources/blockchain_case_study",
        pageName: "blockchain-case-study",
    },
    {
        pathname: "/resources/android_case_study",
        pageName: "android-case-study",
    }
];